var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-card"},[_vm._m(0),_c('div',{staticClass:"date-content"},[_c('span',{staticClass:"date-solar"},[_vm._v(_vm._s(_vm.solarDate))]),_c('span',{staticClass:"date-divider"},[_vm._v("|")]),_c('span',{staticClass:"date-lunar"},[_vm._v(_vm._s(_vm.lunarDate))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-icon"},[_c('i',{staticClass:"el-icon-date"})])
}]

export { render, staticRenderFns }